export const NEW_SALES = 'app:tooHotToMiss';
export const COUPONS__POPULAR = 'app:popular';
export const COUPONS__NEWEST = 'app:couponsAndDeals';
export const COUPONS = 'app:coupons';
